import { createApi } from "@reduxjs/toolkit/dist/query/react";
import baseQuery from "../../baseQuery";
import {
  AvatarsResponse,
  InitResponse,
  SkillsResponse,
} from "../../../../interfaces/general.types";
import { Translations } from "../../../../interfaces/translations.type";

export const generalApi = createApi({
  reducerPath: "generalApi",
  baseQuery,
  endpoints: (builder) => ({
    init: builder.query<InitResponse, void>({
      query: () => "init",
    }),
    getAvatars: builder.query<AvatarsResponse, void>({
      query: () => "repository/avatars",
    }),
    getTranslations: builder.query<Translations, void>({
      query: () => "static-texts",
    }),
    getSkills: builder.query<SkillsResponse, void>({
      query: () => "repository/skills",
    }),
  }),
});

export const {
  useInitQuery,
  useGetAvatarsQuery,
  useGetTranslationsQuery,
  useGetSkillsQuery,
} = generalApi;
